const MESES = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'];

export const ACTIVIDAD_COLUMNS = [
  { key: 'id', label: 'id', type: 'number' },
  { key: 'actividad', label: 'actividad', type: 'string', required: true },
  { key: 'resumen', label: 'resumen', type: 'string', required: true },
  { key: 'title', label: 'title', type: 'string' },
  { key: 'obligatorio', label: 'obligatorio', type: 'boolean' },
  { key: 'intervalo_repeticion', label: 'intervalo_repeticion', type: 'string' },
  { key: 'tipo_intervalo', label: 'tipo_intervalo', type: 'string' },
  { key: 'es_repetitiva', label: 'es_repetitiva', type: 'boolean' },
  { key: 'id_categoria', label: 'id_categoria', type: 'number' },
  { key: 'categoria_nombre', label: 'categoria_nombre', type: 'string', readonly: true },
  { key: 'id_item_coleccion', label: 'id_item_coleccion', type: 'number' },
  { key: 'item_nombre', label: 'item_nombre', type: 'string', readonly: true },
  ...MESES.map((m) => ({ key: m, label: m, type: 'boolean' })),
];
